import memoize from 'lodash/memoize'
import { ContextApi } from '@pancakeswap/localization'
import { PageMeta } from './types'
import { DACKIE_ASSET_CDN } from './endpoints'

export const DEFAULT_META: PageMeta = {
  title: 'DackieSwap',
  description:
    'DackieSwap: #1 Native and Most Trusted DEX on Base. Designed to empower the cryptocurrency community by providing a user-friendly and secure platform, DackieSwap aims to revolutionize the world of decentralized trading.',
  image: `${DACKIE_ASSET_CDN}/images/dackie_home.jpg`,
}

interface PathList {
  paths: { [path: string]: { title: string; basePath?: boolean; description?: string; image?: string } }
  defaultTitleSuffix: string
}

const getPathList = (t: ContextApi['t']): PathList => {
  return {
    paths: {
      '/': { title: t('Home') },
      '/swap': { basePath: true, title: t('Exchange'), image: `${DACKIE_ASSET_CDN}/images/dackie_swap.jpg` },
      '/liquidity/add': {
        basePath: true,
        title: t('Add Liquidity'),
        image: `${DACKIE_ASSET_CDN}/images/dackie_liquidity.jpg`,
      },
      '/liquidity/remove': {
        basePath: true,
        title: t('Remove Liquidity'),
        image: `${DACKIE_ASSET_CDN}/images/dackie_liquidity.jpg`,
      },
      '/liquidity': { title: t('Liquidity'), image: `${DACKIE_ASSET_CDN}/images/dackie_liquidity.jpg` },
      '/ido': { basePath: true, title: t('Pad'), image: `${DACKIE_ASSET_CDN}/images/dackie_ido.jpg` },
      '/find': { title: t('Import Pool') },
      '/farms': { basePath: true, title: t('Farms'), image: `${DACKIE_ASSET_CDN}/images/dackie_farms.jpg` },
      '/pools': { basePath: true, title: t('Pools'), image: `${DACKIE_ASSET_CDN}/images/dackie_pools.jpg` },
      '/points': { basePath: true, title: t('Points'), image: `${DACKIE_ASSET_CDN}/images/dackie_quackpoints.jpg` },
      '/info': {
        basePath: true,
        title: `${t('Overview')} - ${t('Analytics')}`,
        description: 'View statistics for Dackieswap exchanges.',
        image: `${DACKIE_ASSET_CDN}/images/dackie_analytics.jpg`,
      },
      '/info/pairs': {
        basePath: true,
        title: `${t('Pairs')} - ${t('Analytics')}`,
        description: 'View statistics for Dackieswap exchanges.',
        image: `${DACKIE_ASSET_CDN}/images/dackie_analytics.jpg`,
      },
      '/info/tokens': {
        basePath: true,
        title: `${t('Tokens')} - ${t('Analytics')}`,
        description: 'View statistics for Dackieswap exchanges.',
        image: `${DACKIE_ASSET_CDN}/images/dackie_analytics.jpg`,
      },
    },
    defaultTitleSuffix: t('DackieSwap'),
  }
}

export const getCustomMeta = memoize(
  (path: string, t: ContextApi['t'], _: string): PageMeta => {
    const pathList = getPathList(t)
    const pathMetadata =
      pathList.paths[path] ??
      pathList.paths[Object.entries(pathList.paths).find(([url, data]) => data.basePath && path.startsWith(url))?.[0]]

    if (pathMetadata) {
      return {
        title: `${pathMetadata.title}`,
        ...(pathMetadata.description && { description: pathMetadata.description }),
        image: pathMetadata.image,
      }
    }
    return null
  },
  (path, t, locale) => `${path}#${locale}`,
)
